import { render, staticRenderFns } from "./UnityAppLoadingScreen.vue?vue&type=template&id=65c7fbbe&scoped=true"
import script from "./UnityAppLoadingScreen.vue?vue&type=script&lang=js"
export * from "./UnityAppLoadingScreen.vue?vue&type=script&lang=js"
import style0 from "./UnityAppLoadingScreen.vue?vue&type=style&index=0&id=65c7fbbe&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65c7fbbe",
  null
  
)

export default component.exports